import Avatar from 'components/base/Avatar';
import { Dropdown, Nav } from 'react-bootstrap';
// import avatar57 from 'assets/img/team/40x40/57.webp';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import { useAppContext } from 'providers/AppProvider';
import { Link, useNavigate } from 'react-router-dom';
import ThemeToggler from 'components/common/ThemeToggler';
import { useState, useEffect } from 'react';
import avatar from 'assets/img/team/avatar-rounded.webp';

const NavItems = () => {
  useAppContext();
  const navigate = useNavigate();

  // Get environment from localStorage or default to DEV
  const getInitialEnvironment = () => {
    return (localStorage.getItem('SELECTED_ENV') as 'DEV' | 'PROD') || 'DEV';
  };

  const [, setEnvironment] = useState<'DEV' | 'PROD'>(getInitialEnvironment());

  // Get user role from localStorage
  const userRole = (localStorage.getItem('role') || '').toLowerCase();
  const isDeveloper = userRole === 'developer';

  // If user is Developer and PROD is selected, force switch to DEV (runs once on mount)
  useEffect(() => {
    const currentEnv = localStorage.getItem('SELECTED_ENV');
    if (isDeveloper && currentEnv === 'PROD') {
      setEnvironment('DEV');
      localStorage.setItem('SELECTED_ENV', 'DEV');
    }
  }, [isDeveloper]); // setEnvironment is stable from useState, so it's safe to omit

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _handleEnvironmentChange = (value: 'DEV' | 'PROD') => {
    setEnvironment(value);
    localStorage.setItem('SELECTED_ENV', value);

    // Navigate to all-projects page with the selected environment
    const userId = localStorage.getItem('userId');
    if (userId) {
      navigate(`/project/${userId}/all-projects`);
    }
  };

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* <Nav.Item>
        <Nav.Link
          target="_blank"
          rel="noopener noreferrer"
          href={'https://api-doc.microeai.com'}
        >
          API DOCS
        </Nav.Link>
      </Nav.Item> */}

      {/* Environment Dropdown */}
      {/* <Nav.Item>
        <FormControl size="small" sx={{ minWidth: 90, mr: 1 }}>
          <Select
            value={environment}
            onChange={e =>
              handleEnvironmentChange(e.target.value as 'DEV' | 'PROD')
            }
            sx={{
              height: '32px',
              fontSize: '13px',
              fontWeight: 600,
              backgroundColor: 'background.paper'
            }}
          >
            <MenuItem value="DEV">DEV</MenuItem>
            <MenuItem value="PROD" disabled={isDeveloper}>
              PROD {isDeveloper && '(Admin Only)'}
            </MenuItem>
          </Select>
        </FormControl>
      </Nav.Item> */}

      <Nav.Item>
        <ThemeToggler className="px-2" />
      </Nav.Item>
      {/* <Nav.Item
        className={classNames({
          'd-lg-none':
            navbarPosition === 'vertical' || navbarPosition === 'dual'
        })}
      >
        <Nav.Link onClick={() => setOpenSearchModal(!openSearchModal)}>
          <FeatherIcon icon="search" size={19} style={{ marginBottom: 2 }} />
        </Nav.Link>
      </Nav.Item> */}
      {/* <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <FeatherIcon icon="bell" size={20} />
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link h-100"
            variant=""
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}
      <Nav.Item className="d-flex align-items-center me-2">
        <span className="text-body-emphasis fw-semibold">
          Hi,{' '}
          {(() => {
            const firstName = localStorage.getItem('firstName');
            if (firstName) {
              return firstName;
            }
            // Fallback: extract first part of email if available
            const username = localStorage.getItem('username') || '';
            if (username) {
              const emailPart = username.split('@')[0];
              return emailPart.charAt(0).toUpperCase() + emailPart.slice(1);
            }
            return 'User';
          })()}
        </span>
      </Nav.Item>
      <Nav.Item>
        <Dropdown autoClose="outside" className="h-100">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0 lh-1 h-100 d-flex align-items-center"
            variant=""
          >
            <Avatar src={avatar} size="l" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>
      {/* <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: 'auto' }}
          ></DropdownSearchBox>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default NavItems;
